import {
  Component,
  ContentChild,
  HostListener,
  ElementRef,
  EventEmitter,
  Output,
} from "@angular/core";
import { ViewMode2Directive } from "./directives/view-mode2.directive";
import { EditMode2Directive } from "./directives/edit-mode2.directive";
import { fromEvent, Subject } from "rxjs";
import { filter, take, switchMapTo } from "rxjs/operators";
import { untilDestroyed } from "ngx-take-until-destroy";
@Component({
  selector: "editable2",
  template: ` <ng-container *ngTemplateOutlet="currentView"></ng-container> `,
})
export class Editable2Component {
  @ContentChild(ViewMode2Directive) viewModeTpl: ViewMode2Directive;
  @ContentChild(EditMode2Directive) editModeTpl: EditMode2Directive;

  @Output() update = new EventEmitter();

  editMode = new Subject();
  editMode$ = this.editMode.asObservable();

  isEdit = false;

  mode: "view" | "edit" = "view";

  constructor(private host: ElementRef) {}

  ngOnInit() {
    this.viewModeHandler();
    this.editModeHandler();
  }

  toViewMode() {
    this.update.next();
    this.mode = "view";
  }

  private get element() {
    return this.host.nativeElement;
  }

  private viewModeHandler() {
    fromEvent(this.element, "dblclick")
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.mode = "edit";
        this.editMode.next(true);
      });
  }

  private editModeHandler() {
    const clickOutside$ = fromEvent(document, "dblclick").pipe(
      filter(({ target }) => this.element.contains(target) === false),
      take(1)
    );

    this.editMode$
      .pipe(switchMapTo(clickOutside$), untilDestroyed(this))
      .subscribe((event) => this.toViewMode());
  }

  get currentView() {
    return this.mode === "view" ? this.viewModeTpl.tpl : this.editModeTpl.tpl;
  }

  @HostListener("keyup.esc")
  onEscape() {
    return (this.mode = "view");
  }

  ngOnDestroy() {}
}
